// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconDog = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12 16l-2-3h4zm-1-7a1 1 0 11-2 0 1 1 0 012 0m3 1a1 1 0 100-2 1 1 0 000 2" />,
    <path
      fillRule="evenodd"
      d="M5.256 3h13.488L22.2 14.518l-4.2 2.1v.882a3.5 3.5 0 01-6 2.45 3.5 3.5 0 01-6-2.45v-.882l-4.2-2.1zm14.545 10.482l-1.801.9V12h-2v5.5a1.5 1.5 0 01-3 0h-2a1.5 1.5 0 01-3 0V12H6v2.382l-1.8-.9L6.744 5h10.512z"
    />
  );
export default SvgIconDog;
